import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import BuyNumber from "@/pages/BuyNumber";
import MyNumbers from "@/pages/MyNumbers";
import Deposit from "@/pages/Deposit";
import SmsAI from "@/pages/SmsAI";
import Legal from "@/pages/Legal";
import TelegramFab from "@/components/TelegramFab";

import AdminDashboard from "@/pages/AdminDashboard";
import AdminSettings from "@/pages/AdminSettings";
import AdminCountries from "@/pages/AdminCountries";
import AdminTransactions from "@/pages/AdminTransactions";
import AdminUsers from "@/pages/AdminUsers";
import AdminNumbers from "@/pages/AdminNumbers";
import AdminNotifications from "./pages/AdminNotifications";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: { background: "hsl(0 0% 8%)", color: "white", border: "1px solid hsl(0 0% 15%)" },
          }}
        />
        <Routes>
          {/* Public landing */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/legal/:doc" element={<Legal />} />

          {/* Protected user area */}
          <Route path="/panel" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/buy" element={<ProtectedRoute><BuyNumber /></ProtectedRoute>} />
          <Route path="/numbers" element={<ProtectedRoute><MyNumbers /></ProtectedRoute>} />
          <Route path="/deposit" element={<ProtectedRoute><Deposit /></ProtectedRoute>} />
          <Route path="/sms-ai" element={<ProtectedRoute><SmsAI /></ProtectedRoute>} />

          {/* Admin */}
          <Route path="/yonetimvolki35" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
          <Route path="/yonetimvolki35/transactions" element={<ProtectedRoute adminOnly><AdminTransactions /></ProtectedRoute>} />
          <Route path="/yonetimvolki35/users" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
          <Route path="/yonetimvolki35/numbers" element={<ProtectedRoute adminOnly><AdminNumbers /></ProtectedRoute>} />
          <Route path="/yonetimvolki35/countries" element={<ProtectedRoute adminOnly><AdminCountries /></ProtectedRoute>} />
          <Route path="/yonetimvolki35/settings" element={<ProtectedRoute adminOnly><AdminSettings /></ProtectedRoute>} />
          <Route path="/yonetimvolki35/notifications" element={<ProtectedRoute adminOnly><AdminNotifications /></ProtectedRoute>} />
        </Routes>
        <TelegramFab />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
